/**
 * Conventions for UI elements that should be disabled while a project is in
 * the 'draft' state. Centralised so call sites have one consistent message
 * and behavior to opt into.
 *
 * Usage:
 *   <Button {...draftDisabled(isDraft)} onClick={...}>Export PDF</Button>
 *
 * Adding a new draft-restricted action: just spread `draftDisabled(isDraft)`
 * onto the relevant button or input. Don't invent a new tooltip string —
 * keep the message uniform so users learn the rule once.
 */

export const DRAFT_RESTRICTED_TOOLTIP = 'Available after the project is set active';

export interface DraftDisabledProps {
  disabled: boolean;
  title?: string;
}

export function draftDisabled(isDraft: boolean): DraftDisabledProps {
  return isDraft
    ? { disabled: true, title: DRAFT_RESTRICTED_TOOLTIP }
    : { disabled: false };
}
